import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CurrentContextService } from 'app/core/current-context.service';
import { SubscriptionHandlerBaseComponent } from 'app/core/subscription-handler.base';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-account-upgrade-popup',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountUpgradePopupComponent extends SubscriptionHandlerBaseComponent implements OnInit {
  private triedToAccess: string;

  constructor(
    private readonly currentContextService: CurrentContextService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
    this.triedToAccess = data.triedToAccess;
  }

  ngOnInit(): void {
    super.addSubscription(
      this.currentContextService.currentContextBS
        .pipe(
          filter((currentContext) => !!currentContext),
          take(1),
        )
        .subscribe((currentContext) => {
          this.createEvent('TriggerbeeOpenUpgradePopup', {
            detail: {
              triedToAccess: this.triedToAccess,
              account: currentContext.account,
              tierAccess: currentContext.tierAccess,
              user: currentContext.user,
            },
          });
        }),
    );
  }

  private createEvent(eventName: string, data: any): void {
    document.dispatchEvent(new CustomEvent(eventName, data));
  }
}
